import { useRef } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import OutlinedInput from '@mui/material/OutlinedInput';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ExplorePopularSearchWrapper from '../explorepopularsearchwrapper/ExplorePopularSearchWrapper';

import { ArrowDown2, SearchNormal } from 'iconsax-react';

import classes from './ExploreSearchSidebar.module.scss';
import ExploreCareerFilter from '../explorecareerfilter/ExploreCareerFilter';
import Link from 'next/link';
import LinkButton from '@core/components/linkbutton/LinkButton';

const ExploreSearchSidebar = ({
	filters,
	searchKeyword,
	selectedCategories,
	selectedPrice,
	selectedProficiency,
	selectedHighlighted,
	selectedCareerPath,
	handleCategoryClick,
	handlePriceClick,
	handleProficiencyClick,
	handleQueryKeywordChange,
	handleHighlightedChange,
	handleCareerPathChange,
}) => {
	const isMountedRef = useRef(false);

	const handleKeyWordChange = (e) => {
		handleQueryKeywordChange(e);
		window.scrollTo(0, 0);
	};

	const handleCareerChange = (id) => {
		window.scrollTo(0, 0);
		handleCareerPathChange(id);
	}

	const isAnyFilterActive =
		selectedCategories.length > 0 ||
		selectedPrice.length > 0 ||
		selectedProficiency.length > 0 ||
		selectedCareerPath !== null && selectedCareerPath !== undefined && selectedCareerPath !== '' ||
		selectedHighlighted.length > 0 ||
		(searchKeyword && searchKeyword.trim() !== '');

	return (
		<>
			{filters && (
				<div className={`${classes['explore-search-sidebar-wrapper']} d-flex flex-column gap-2`}>
					<div>
						<div className={classes['header']}>
							<p>Filters</p>
							{isAnyFilterActive && (
								<LinkButton to="/explore?featured_contents=true" kind='simple' className={classes['clear-filters']}>
									Clear Filters
								</LinkButton>
							)}
						</div>


						<div className={classes['filters-wrapper']}>

							{/* remove category filter */}
							{/* <Accordion
								sx={{
									display: 'none',
									border: 'none',
									boxShadow: 'none',
									borderBottom: '1px solid #A6A5A3',
									margin: '0',
									paddingBottom: '32px',
								}}
								defaultExpanded>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="panel1a-content"
									id="panel1a-header"
									className={`${classes['accordion-header']}`}>
									Categories
								</AccordionSummary>
								<AccordionDetails className="p-0">
									<div className="d-flex flex-column gap-4">
										{filters?.categories?.map((category) => {
											return (
												<FormControlLabel
													key={category.id}
													required
													control={
														<Checkbox
															checked={selectedCategories.includes(category.id)}
															onClick={() => handleCategoryClick(category.id)}
														/>
													}
													label={
														<div
															className={`${classes['explore-side-category-card']} d-flex flex-row align-items-center`}>
															<div
																className={`${classes['explore-side-category-card__details']} d-flex flex-row gap-3`}>
																<div style={{ backgroundColor: category.color + '30' }}>
																	<img src={category.image} alt={category.name} />
																</div>
																<div className="d-flex flex-wrap flex-column gap-2 justify-content-center">
																	<h5>{category.name}</h5>
																	<p>
																		{category.course_count} Job Qualifications{' '}
																		<span className={classes['dot']} /> {category.lecture_count}{' '}
																		Courses
																	</p>
																</div>
															</div>
														</div>
													}
												/>
											);
										})}
									</div>
								</AccordionDetails>
							</Accordion> */}
							{/* <Accordion
								className={classes['accordion']}
								sx={{
									border: 'none',
									boxShadow: 'none',
									borderBottom: '1px solid #A6A5A3',
									margin: '0',
									paddingBottom: '32px'
								}}
								defaultExpanded>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="panel3a-content"
									id="panel3a-header"
									className={`${classes['accordion-header']}`}>
									Highlighted Learning
								</AccordionSummary>
								<AccordionDetails className={classes["accordion-item"]}>
									<div className="d-flex flex-column gap-3">
										<FormControlLabel											
											control={
												<Checkbox
													checked={selectedHighlighted.includes('featured')}
													onClick={() => handleHighlightedChange('featured')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Featured</h5>
													</div>
												</div>
											}
										/>
									</div>
								</AccordionDetails>
							</Accordion> */}
							<Accordion
								className={classes['accordion']}
								sx={{
									border: 'none',
									boxShadow: 'none',
									margin: '0',
									paddingY: '12px',
									borderRadius: '0',
									borderBottom: '1px solid #A6A5A3'
								}}
								defaultExpanded={false}>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="panel2a-content"
									id="panel2a-header"
									className={`${classes['accordion-header']}`}>
									Proficiency
								</AccordionSummary>
								<AccordionDetails className={classes["accordion-item"]}>
									<div className="d-flex flex-column gap-3">
										<FormControlLabel
											className={`${classes['proficiency-item']} ${selectedProficiency.includes('beginner') ? classes['beginner-selected'] : ''}`}
											control={
												<Checkbox
													checked={selectedProficiency.includes('beginner')}
													onClick={() => handleProficiencyClick('beginner')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Beginner</h5>
													</div>
												</div>
											}
										/>
										<FormControlLabel
											className={`${classes['proficiency-item']} ${selectedProficiency.includes('intermediate') ? classes['intermediate-selected'] : ''}`}
											control={
												<Checkbox
													checked={selectedProficiency.includes('intermediate')}
													onClick={() => handleProficiencyClick('intermediate')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Intermediate</h5>
													</div>
												</div>
											}
										/>
										<FormControlLabel
											className={`${classes['proficiency-item']} ${selectedProficiency.includes('advanced') ? classes['advanced-selected'] : ''}`}
											control={
												<Checkbox
													checked={selectedProficiency.includes('advanced')}
													onClick={() => handleProficiencyClick('advanced')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Advanced</h5>
													</div>
												</div>
											}
										/>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								className={classes['accordion']}
								sx={{
									border: 'none',
									boxShadow: 'none',
									margin: '0',
									paddingY: '12px',
									borderRadius: '0',
									borderBottom: '1px solid #A6A5A3'
								}}
								defaultExpanded={false}>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="panel2a-content"
									id="panel2a-header"
									className={`${classes['accordion-header']}`}>
									Price
								</AccordionSummary>
								<AccordionDetails className={classes["accordion-item"]}>
									<div className="d-flex flex-column gap-3">
										<FormControlLabel
											className={`${classes['proficiency-item']} ${selectedPrice.includes('free') ? classes['free-selected'] : ''}`}
											control={
												<Checkbox
													checked={selectedPrice.includes('free')}
													onClick={() => handlePriceClick('free')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Free</h5>
													</div>
												</div>
											}
										/>
										<FormControlLabel
											className={`${classes['proficiency-item']} ${selectedPrice.includes('paid') ? classes['intermediate-selected'] : ''}`}
											control={
												<Checkbox
													checked={selectedPrice.includes('paid')}
													onClick={() => handlePriceClick('paid')}
												/>
											}
											label={
												<div
													className={`${classes['explore-side-price-card']} d-flex flex-row align-items-center`}>
													<div
														className={`${classes['explore-side-price-card__details']} d-flex flex-wrap flex-column gap-1 justify-content-center`}>
														<h5>Premium</h5>
													</div>
												</div>
											}
										/>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								className={classes['accordion']}
								sx={{
									border: 'none',
									boxShadow: 'none',
									margin: '0',
									paddingY: '12px',
									borderRadius: '0',
									borderBottom: '1px solid #A6A5A3'
								}}
								defaultExpanded={false}>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="panel2a-content"
									id="panel2a-header"
									className={`${classes['accordion-header']}`}>
									Popular Searches
								</AccordionSummary>
								<AccordionDetails className={classes["accordion-item"]}>
									<ExplorePopularSearchWrapper searchKeyword={searchKeyword} handleKeyWordChange={handleKeyWordChange} />
								</AccordionDetails>
							</Accordion>
							<Accordion
								className={classes['accordion']}
								sx={{
									border: 'none',
									boxShadow: 'none',
									margin: '0',
									paddingY: '12px',
									borderRadius: '0',
								}}
								defaultExpanded={false}>
								<AccordionSummary
									expandIcon={<ArrowDown2 />}
									aria-controls="career-content"
									id="career-header"
									className={`${classes['accordion-header']}`}>
									Career Paths
								</AccordionSummary>
								<AccordionDetails className={classes["accordion-item"]}>
									<ExploreCareerFilter
										careerPaths={filters.career_paths}
										selectedId={selectedCareerPath}
										handleCareerChange={handleCareerChange} />
								</AccordionDetails>
							</Accordion>

						</div>
					</div>
				</div >
			)}
		</>
	);
};

export default ExploreSearchSidebar;
